import React, { useState, useEffect, useContext } from "react";
import { Modal, Button, FloatingLabel, Form } from "react-bootstrap";

import UserDialog from "./UserDialog";
import Utils from "../../../Utils";
import ContextComponent from "../../../AppContext";
import ProfilePicture from "./../../../../assets/img/default-profile.png";
import DeleteIcon from "./../../../../assets/img/Delete.png";

const Settings = () => {
  let { userData, setUserData, setLoadingState, setCanRedirectToLogin } = useContext(ContextComponent);

  let [canRender, setCanRender] = useState(false);
  let [canFetchUserProfiles, setCanFetchUserProfiles] = useState(false);
  let [userInfo, setUserInfo] = useState({});
  let [userProfiles, setUserProfiles] = useState([]);
  let [profileImage, setProfileImage] = useState(ProfilePicture);

  useEffect(() => {
    if (!Utils.isObjectEmpty(userData)) {
      if (!!userData.profileImage) {
        setProfileImage(userData.profileImage || ProfilePicture);
      }
      setUserInfo(userData);
    }
  }, [userData]);

  useEffect(() => {
    if (!Utils.isObjectEmpty(userInfo)) {
      //console.log(userInfo);
      setCanRender(true);
      setCanFetchUserProfiles(true);
    }
  }, [userInfo]);

  useEffect(() => {
    const success = (res) => {
      // console.log(res.data);
      setUserProfiles(res.data);
    };

    const fail = ({ error }) => {
      error?.message?.length && console.log(error);
      setErrorMessage(error);
      Utils.handleDefaultError({
        error,
        setLoadingState,
        setCanRedirectToLogin,
      });
    };

    // const fail = (err) => {
    //   console.log(err);
    // };

    if (canFetchUserProfiles) {
      Utils.getAllUserProfiles(userData.id).then(success, fail);
    }
  }, [canFetchUserProfiles]);

  // return;
  // {
  //   canRender && <>user settings page</>;
  // }

  let [showProfileModal, setShowProfileModal] = useState(false);
  let [modalTitle, setModalTitle] = useState("");
  let [postfix, setPostfix] = useState("");

  const handleClose = () => {
    setShowProfileModal(false);
  };

  const openModal = (fieldsToUpdate) => {
    setShowProfileModal(true);
  };

  const allowEmailEdit = (e) => {
    setModalTitle("Change your email ID");
    setPostfix("email");
    openModal("email");
  };

  const allowResetPassword = (e) => {
    setModalTitle("Reset password");
    setPostfix("resetpassword");
    openModal("password");
  };

  const allowMasterProfileEdit = (e) => {
    setModalTitle("Update profile");
    setPostfix("profile");
    openModal("profile");
  };

  const profileFieldChangeHandler = (e) => {
    let fieldName = e.currentTarget.id || "";
    let fieldObj = {};
    fieldObj[fieldName] = e.currentTarget.value;
  };

  let obj = {
    email: ["email"],
    resetpassword: ["password", "confirmPassword"],
    profile: [
      "salutation",
      "firstName",
      "lastName",
      "title",
      "department",
      "pronoun",
      "profileImage",
      "specialText",
    ],
  };

  let [errorMessage, setErrorMessage] = useState("");

  // let [userProfilePicture, setUserProfilePicture] = useState(
  //   userData.picture || ProfilePicture
  // );

  const fileChangeHandler = async (e) => {
    let file = e.currentTarget.files[0];
    await Utils.fileToDataUri(file).then((dataUri) => {
      setProfileImage(dataUri);
    });
  };

  const handleUpdate = (e) => {
    let userObjToBeSubmit = {};
    const success = (response) => {
      setErrorMessage("");
      if (postfix !== "resetpassword") {
        const userFetchSuccess = (response) => {
          setErrorMessage("");
          setUserData(response.data);
          handleClose();
          setLoadingState({
            applyMask: false,
          });
        };
        Utils.getUserProfile().then(userFetchSuccess, fail);
      } else {
        handleClose();
        setLoadingState({
          applyMask: false,
        });
      }
    };

    const fail = ({ error }) => {
      error?.message?.length && console.log(error);
      setErrorMessage(error);
      Utils.handleDefaultError({
        error,
        setLoadingState,
        setCanRedirectToLogin,
      });
    };
    if (postfix === "resetpassword") {
      let emptyExists = false;
      let newPwd = "";
      let conNewPwd = "";
      obj[postfix].map((fieldKey, index) => {
        let pwdValue = document.querySelector("#" + fieldKey).value || "";
        index === 0 && (newPwd = pwdValue);
        index === 1 && (conNewPwd = pwdValue);
        pwdValue.trim().length === 0 && (emptyExists = true);
      });
      if (emptyExists) {
        setErrorMessage("All fields are mandatory");
        return false;
      }

      if (newPwd !== conNewPwd) {
        setErrorMessage("New password and confirm passwords are not matched.");
        return false;
      }
      setErrorMessage("");
      userObjToBeSubmit["newpassword"] = newPwd;
      userObjToBeSubmit["confirmpassword"] = conNewPwd;
      Utils.executeResetPassword(userObjToBeSubmit).then(success, fail);
    } else {
      setLoadingState({
        applyMask: true,
        text: "Updating profile information",
      });

      obj[postfix].map((fieldKey, index) => {
        const fieldEle = document.querySelector("#" + fieldKey);
        fieldEle && (userObjToBeSubmit[fieldKey] = fieldEle.value);
      });
      // userObjToBeSubmit["email"] = userData.email;
      // userObjToBeSubmit["brands"] = userData.brands;
      // userObjToBeSubmit["admin"] = true;
      Utils.editMasterProfile(userObjToBeSubmit, userData.id).then(success, fail);
    }
    // debugger;
  };

  let [userProfileData, setUserProfileData] = useState({
    isMaster: false,
    showUserDialog: false,
    mode: "edit",
    userData: {},
    dialogProps: {
      title: "Update profile",
      postfix: "profile",
    },
  });

  const allowProfileCreate = (e) => {
    setUserProfileData({
      showUserDialog: true,
      mode: "create",
      userData: {
        userId: userData.id,
      },
      dialogTitle: "Create profile",
      dialogSubmitBtnLabel: "Create ",
      progressText: "Creating user profile is in progress",
      userProfiles,
      setUserProfiles,
    });
  };

  const allowUserProfileEdit = (e) => {
    let userProfileId = parseInt(
      e.currentTarget.attributes["userid"].value,
      10
    );
    let existingUserProfile = userProfiles.filter((up) => {
      return userProfileId === up.id;
    })[0];
    // console.log(userProfiles);
    // console.log(userProfileId);
    let editProfileObj = {
      showUserDialog: true,
      mode: "edit",
      userData: {
        ...existingUserProfile,
        ...{
          userId: userData.id,
        },
      },
      dialogTitle: "Edit profile",
      dialogSubmitBtnLabel: "Edit ",
      progressText: "Updating user profile is in progress",
      userProfiles,
      setUserProfiles,
    };
    // console.log(editProfileObj);
    setUserProfileData(editProfileObj);
  };

  let [deletableUserProfile, setDeletableUserProfile] = useState({});

  let [showDeleteUserProfileModal, setShowDeleteUserProfileModal] =
    useState(false);

  const handleUserProfileDeleteDialogClose = () => {
    setShowDeleteUserProfileModal(false);
  };

  const deleteUserProfile = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let userProfileIdToBeDelete = parseInt(
      e.currentTarget.attributes.userid.value,
      10
    );
    // console.log(userProfileIdToBeDelete);
    let tempUserProfiles = [...userProfiles];
    let userProfile = tempUserProfiles.filter((up) => {
      return up.id === userProfileIdToBeDelete;
    })[0];
    setDeletableUserProfile(userProfile);
    setShowDeleteUserProfileModal(true);
    return false;
  };

  const handleDeleteUserProfile = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let userProfileIdToBeDelete = deletableUserProfile.id;
    // console.log(userProfileIdToBeDelete);

    let userObjToBeSubmit = { ...deletableUserProfile };

    setLoadingState({
      applyMask: true,
      text: `Deleting "${deletableUserProfile.profileName}" profile is in progress`,
    });

    const anyCallback = () => {
      setLoadingState({
        applyMask: false,
      });
      setShowDeleteUserProfileModal(false);
    };

    const deleteSuccess = (response) => {
      anyCallback();

      let tempUserProfiles = [...userProfiles];
      let tempUserProfile = [];
      tempUserProfiles.forEach((up) => {
        if (up.id !== deletableUserProfile.id) {
          tempUserProfile.push(up);
        }
      });
      setUserProfiles(tempUserProfile);
    };

    const deleteFail = ({ error }) => {
      error?.message?.length && console.log(error);
      setErrorMessage(error);
      Utils.handleDefaultError({
        error,
        setLoadingState,
        setCanRedirectToLogin,
      });
    };
    Utils.deleteProfile(deletableUserProfile).then(deleteSuccess, deleteFail);
  };

  return (
    <>
      <UserDialog props={{ userProfileData }}></UserDialog>
      <Modal centered show={showProfileModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="indi-modal-edit-user-profile-header-title">
            {modalTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className={`indi-modal-edit-user-profile-email-section indi-modal-edit-user-profile-${postfix}`}
          >
            <FloatingLabel label="Email">
              <Form.Control
                type="text"
                className="indi-input-field"
                id="email"
                placeholder="Enter email"
                autoComplete="off"
                defaultValue={userData.email}
                onChange={profileFieldChangeHandler}
              />
            </FloatingLabel>
          </div>
          <div
            className={`indi-modal-edit-user-profile-resetpassword-section indi-modal-edit-user-profile-${postfix}`}
          >
            <div>
              <FloatingLabel
                label="New password"
                className="indi-modal-edit-user-profile-floating-inputs"
              >
                <Form.Control
                  type="password"
                  className="indi-input-field"
                  id="password"
                  placeholder="Enter new password"
                  autoComplete="off"
                  onChange={profileFieldChangeHandler}
                />
              </FloatingLabel>
              <FloatingLabel
                label="Confirm password"
                className="indi-modal-edit-user-profile-floating-inputs"
              >
                <Form.Control
                  type="password"
                  className="indi-input-field"
                  id="confirmPassword"
                  placeholder="Enter confirm password"
                  autoComplete="off"
                  onChange={profileFieldChangeHandler}
                />
              </FloatingLabel>
            </div>
          </div>
          <div
            className={`indi-modal-edit-user-profile-profile-section indi-modal-edit-user-profile-${postfix}`}
          >
            <div>
              <div className="indi-card-upload-picture-file-input-wrapper">
                <input
                  type="file"
                  onChange={fileChangeHandler}
                  className="indi-card-upload-picture-file-input"
                />
                <input
                  type="hidden"
                  id="profileImage"
                  defaultValue={profileImage}
                />
                <img
                  className="indi-card-upload-picture-img-input"
                  src={profileImage}
                  alt="profilepic"
                />
              </div>
            </div>

            <FloatingLabel
              label="First name"
              className="indi-modal-edit-user-profile-floating-inputs"
            >
              <Form.Control
                type="text"
                className="indi-input-field"
                id="firstName"
                placeholder="Enter first name"
                autoComplete="off"
                defaultValue={userData.firstName}
                onChange={profileFieldChangeHandler}
              />
            </FloatingLabel>
            <FloatingLabel
              label="Last name"
              className="indi-modal-edit-user-profile-floating-inputs"
            >
              <Form.Control
                type="text"
                className="indi-input-field"
                id="lastName"
                placeholder="Enter last name"
                autoComplete="off"
                defaultValue={userData.lastName}
                onChange={profileFieldChangeHandler}
              />
            </FloatingLabel>
            <FloatingLabel
              label="Title"
              className="indi-modal-edit-user-profile-floating-inputs"
            >
              <Form.Control
                type="text"
                className="indi-input-field"
                id="title"
                placeholder="Enter title"
                autoComplete="off"
                defaultValue={userData.title}
                onChange={profileFieldChangeHandler}
              />
            </FloatingLabel>
            <FloatingLabel
              label="Department"
              className="indi-modal-edit-user-profile-floating-inputs"
            >
              <Form.Control
                type="text"
                className="indi-input-field"
                id="department"
                placeholder="Enter department"
                autoComplete="off"
                defaultValue={userData.department}
                onChange={profileFieldChangeHandler}
              />
            </FloatingLabel>
            <FloatingLabel
              label="Special Text"
              className="indi-modal-edit-user-profile-floating-inputs"
            >
              <Form.Control
                type="text"
                className="indi-input-field"
                id="specialText"
                placeholder="Enter Special Text"
                autoComplete="off"
                defaultValue={userData.specialText}
                onChange={profileFieldChangeHandler}
              />
            </FloatingLabel>

            {/* <FloatingLabel
              label="Brand"
              className="indi-modal-edit-user-profile-floating-inputs"
            >
              <Form.Control
                type="text"
                className="indi-input-field"
                id="brand"
                placeholder="Enter brand"
                autoComplete="off"
                defaultValue={userData.brands[0]}
                onChange={profileFieldChangeHandler}
              />
            </FloatingLabel> */}

            <FloatingLabel label="Select salutation">
              <Form.Select
                defaultValue={userData.salutation}
                id="salutation"
                size="sm"
                className="indi-input-field indi-input-select-field"
                onChange={profileFieldChangeHandler}
              >
                {Object.keys(Utils.SALUTATION)?.map((key, index) => (
                  <option value={key} key={index}>
                    {Utils.SALUTATION[key]}
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>

            <FloatingLabel label="Select pronoun">
              <Form.Select
                defaultValue={userData.pronoun}
                id="pronoun"
                size="sm"
                className="indi-input-field indi-input-select-field"
                onChange={profileFieldChangeHandler}
              >
                {Object.keys(Utils.PRONOUNS)?.map((key, index) => (
                  <option value={key} key={index}>
                    {Utils.PRONOUNS[key]}
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="indi-user-profile-settings-error-msg">
            {errorMessage}
          </div>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleUpdate}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>

      {canRender && (
        <div className="d-flex indi-user-settings-page-wrapper">
          <div className="indi-user-settings-page-header w-100">
            User settings page
          </div>
          <div className="d-flex">
            <div className="indi-user-settings-page-account indi-user-settings-page-card">
              <div className="indi-user-settings-page-card-header d-flex">
                <img
                  className="indi-user-settings-page-card-header-img"
                  src={ProfilePicture}
                  alt=""
                />{" "}
                <div className="indi-user-settings-page-card-header-label">
                  Account
                </div>
              </div>
              <div className="indi-user-settings-page-card-inner d-flex">
                <div
                  role="button"
                  //onClick={allowEmailEdit}
                  className="indi-user-settings-page-change-email d-flex indi-user-settings-page-card-inner-item"
                >
                  <div className="indi-user-settings-page-change-email-label">
                    Your email ID
                  </div>
                  <div className="indi-user-settings-page-change-email-value">
                    {userInfo.email}
                  </div>
                </div>

                <div
                  role="button"
                  onClick={allowResetPassword}
                  className="indi-user-settings-page-reset-password indi-user-settings-page-card-inner-item"
                >
                  Reset password
                </div>
              </div>
            </div>

            <div className="indi-user-settings-page-profile indi-user-settings-page-card">
              <div className="indi-user-settings-page-card-header d-flex">
                <img
                  className="indi-user-settings-page-card-header-img"
                  src={ProfilePicture}
                  alt=""
                />{" "}
                <div className="indi-user-settings-page-card-header-label">
                  Profiles
                </div>
                <div
                  role="button"
                  onClick={allowProfileCreate}
                  className="indi-place-me-top-right indi-user-settings-add-profile-btn"
                >
                  +
                </div>
              </div>

              <div
                role="button"
                onClick={allowMasterProfileEdit}
                className="indi-user-settings-page-card-inner d-flex"
              >
                <div className="indi-user-settings-page-image-wrapper">
                  <img
                    className="indi-user-settings-page-image"
                    src={profileImage}
                    alt="profileImage"
                  />
                </div>
                <div className="indi-user-settings-page-display-name">
                  {userInfo.firstName} {userInfo.lastName}
                </div>
              </div>

              <div className="indi-user-settings-page-card-profile-wrapper">
                {userProfiles?.map((userProfile, index) => (
                  <div
                    key={index}
                    role="button"
                    userid={userProfile.id}
                    onClick={allowUserProfileEdit}
                    className="indi-user-settings-page-card-inner indi-user-settings-page-card-inner-profile d-flex"
                  >
                    <div className="indi-user-settings-page-display-name">
                      {userProfile.profileName}
                    </div>

                    <div
                      className={`indi-user-profile-delete-btn indi-place-me-top-right`}
                      role="button"
                      userid={userProfile.id}
                      onClick={deleteUserProfile}
                    >
                      <img
                        className="indi-w-20"
                        src={DeleteIcon}
                        alt="edit-icon"
                      ></img>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      <Modal
        centered
        show={showDeleteUserProfileModal}
        onHide={handleUserProfileDeleteDialogClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete user profile confirmation?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure to delete "{deletableUserProfile.profileName}" profile?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleUserProfileDeleteDialogClose}
          >
            No
          </Button>
          <Button variant="primary" onClick={handleDeleteUserProfile}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Settings;
